import { ColDef } from 'ag-grid';
import * as PropTypes from 'prop-types';
import { GridProps } from '../../../props';

export interface Props {
  value: number;
  colDef: ColDef;
  context: GridProps;
}

export interface ActionProps {
  icon: string;
  callback: (id: number) => void;
}

export const propTypes = {
  value: PropTypes.string.isRequired,
  colDef: PropTypes.object.isRequired,
  context: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/actions/props.ts